// frontend/src/store.js

import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';

/**
 * The central Redux store for the application.
 *
 * It uses `configureStore` from Redux Toolkit, which automatically sets up
 * the Redux DevTools Extension and includes helpful middleware by default.
 */
export const store = configureStore({
  reducer: {
    // The 'auth' key here corresponds to the state slice managed by authReducer.
    // The entire authentication state (accessToken, user) will be available
    // under `state.auth` in any component connected to the store.
    auth: authReducer,

    // As the application grows, you can add more reducers for other
    // parts of your application's state, for example:
    // portfolio: portfolioReducer,
    // settings: settingsReducer,
  },
});